import Crud from '../views/Cbo/Crud'
import Entity from '../views/Cbo/Add'
import View from '../views/Cbo/View'

let routes = {
    path: '/cbo',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/cbos/add',
            name: 'NewCbo',
            component: Entity,
            meta: {
                pageTitle: 'Criação de CBO`s',
                breadcrumb: [
                    {
                        text: 'CBO`s',
                        active: false,
                        to: '/cbos',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/cbos/edit/:id?',
            name: 'EditCbo',
            component: Entity,
            meta: {
                pageTitle: 'Edição de CBO`s',
                breadcrumb: [
                    {
                        text: 'CBO`s',
                        active: false,
                        to: '/cbos',
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/cbos/view/:id?',
            name: 'ViewCbo',
            component: View,
            meta: {
                pageTitle: 'Visualizar CBO`s',
                breadcrumb: [
                    {
                        text: 'CBO`s',
                        active: false,
                        to: '/cbos',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/cbos',
            name: 'list-cbos',
            component: Crud,
            meta: {
                pageTitle: 'Lista de CBO`s',
                breadcrumb: [
                    {
                        text: 'CBO`s',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
